//移动端导航栏 - 重新设计

import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../pages/action";
import LogoutConfirmDialog from "../../LogoutConfirmDialog";

const StyledAppBar = styled(AppBar)`
  background: transparent;
  box-shadow: none;
  transition: all 0.3s ease;
  z-index: 1200;

  &:hover {
    background: transparent;
  }
`;

const LogoWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 80px;
    height: 80px;
  }
`;

const MobileNavItem = styled(ListItem)(({ theme, active }) => ({
  padding: "12px 24px",
  borderRadius: "8px",
  margin: "4px 16px",
  backgroundColor: active ? "rgba(0, 0, 0, 0.04)" : "transparent",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.06)",
  },
}));

const MobileNavLink = styled(Link)`
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  width: 100%;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
`;

const SubMenuList = styled(List)`
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  margin: 0 16px 8px;
  padding: 8px 0;
`;

const SubMenuItem = styled(ListItem)(({ theme, active }) => ({
  padding: "8px 16px",
  borderRadius: "6px",
  margin: "2px 8px",
  backgroundColor: active ? "rgba(0, 0, 0, 0.04)" : "transparent",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.06)",
  },
}));

const MobileNavbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [mobileSubmenuOpen, setMobileSubmenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const handleMenuItemClick = (sectionId) => {
    if (location.pathname !== "/intro") {
      navigate("/intro");
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    setDrawerOpen(false);
  };

  const handleNavLinkClick = (path) => {
    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate(path);
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const handleMobileNavClick = (path) => {
    handleNavLinkClick(path);
    setDrawerOpen(false);
  };

  const toggleMobileSubmenu = () => {
    setMobileSubmenuOpen(!mobileSubmenuOpen);
  };

  const handleMobileSubmenuClick = (sectionId) => {
    handleMenuItemClick(sectionId);
    setDrawerOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  const handleAuthClick = (e) => {
    e.preventDefault();

    if (isLoggedIn) {
      setLogoutDialogOpen(true);
      setDrawerOpen(false);
    } else {
      navigate("/login");
      setDrawerOpen(false);
    }
  };

  const handleConfirmLogout = () => {
    dispatch(logout());
    localStorage.removeItem("token");
    localStorage.removeItem("refreshtoken");
    localStorage.removeItem("username");
    navigate("/");
    setLogoutDialogOpen(false);
  };

  return (
    <>
      <StyledAppBar position="static">
        <Toolbar sx={{ height: "80px", px: "16px" }}>
          <LogoWrapper>
            <img src="/images/logo/logowhite.svg" alt="3CCA Logo" />
          </LogoWrapper>

          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
            sx={{
              color: "rgba(255, 255, 255, 0.9)",
              width: 40,
              height: 40,
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              },
            }}
          >
            <MenuIcon sx={{ fontSize: "24px" }} />
          </IconButton>
        </Toolbar>
      </StyledAppBar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            width: "85%",
            maxWidth: "320px",
            background: "#fff",
            boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)",
            borderRadius: { xs: "12px 0 0 12px" },
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "1.1rem" }}>
            菜单导航
          </Typography>
          <IconButton
            onClick={toggleDrawer(false)}
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.03)",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.06)",
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <List sx={{ pt: 1, pb: 2 }}>
          <MobileNavItem active={isActive("/")}>
            <MobileNavLink to="/" onClick={() => handleMobileNavClick("/")}>
              主页
            </MobileNavLink>
          </MobileNavItem>

          <MobileNavItem active={isActive("/intro") || location.hash}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
              }}
              onClick={toggleMobileSubmenu}
            >
              <MobileNavLink to="#" onClick={(e) => e.preventDefault()}>
                简介
              </MobileNavLink>
              <IconButton
                size="small"
                sx={{
                  p: 0.5,
                  backgroundColor: mobileSubmenuOpen
                    ? "rgba(0, 0, 0, 0.04)"
                    : "transparent",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.08)",
                  },
                }}
              >
                {mobileSubmenuOpen ? (
                  <ExpandLessIcon fontSize="small" />
                ) : (
                  <ExpandMoreIcon fontSize="small" />
                )}
              </IconButton>
            </Box>
          </MobileNavItem>

          <Collapse in={mobileSubmenuOpen} timeout="auto" unmountOnExit>
            <SubMenuList>
              {[
                { id: "section-1", title: "1. 3C基督徒联盟是什么？" },
                { id: "section-2", title: "2. 3C基督徒联盟是做什么的？" },
                { id: "section-3.1", title: "3. 为什么要做3C基督徒联盟？" },
                { id: "section-4.1", title: "4. 3C基督徒联盟的异象是什么？" },
                { id: "section-5", title: "5. 3C基督徒联盟有什么特点？" },
                { id: "section-6", title: "6. 3C基督徒联盟的盟约是什么？" },
                { id: "section-7", title: "7. 我为什么要加入3C基督徒联盟？" },
                {
                  id: "section-8.1",
                  title: "8.1 作为事奉同工，如何加入3C基督徒联盟？",
                },
                {
                  id: "section-8.2",
                  title: "8.2 作为实名会友，如何加入3C基督徒联盟？",
                },
                {
                  id: "section-8.3",
                  title: "8.3 作为匿名会友，如何加入3C基督徒联盟？",
                },
                {
                  id: "section-9",
                  title: "9. 3C基督徒联盟的线上平台是什么样的？",
                },
              ].map((item) => (
                <SubMenuItem
                  key={item.id}
                  onClick={() => handleMobileSubmenuClick(item.id)}
                  button
                >
                  <ListItemText
                    primary={item.title}
                    primaryTypographyProps={{
                      fontSize: "0.9rem",
                      fontWeight: 400,
                      color: "rgba(0, 0, 0, 0.75)",
                    }}
                  />
                </SubMenuItem>
              ))}
            </SubMenuList>
          </Collapse>

          <MobileNavItem active={isActive("/worship")}>
            <MobileNavLink
              to="/worship"
              onClick={() => handleMobileNavClick("/worship")}
            >
              3CCA崇拜
            </MobileNavLink>
          </MobileNavItem>

          <MobileNavItem active={isActive("/vision")}>
            <MobileNavLink
              to="/vision"
              onClick={() => handleMobileNavClick("/vision")}
            >
              异象空间
            </MobileNavLink>
          </MobileNavItem>

          <MobileNavItem active={isActive("/serve")}>
            <MobileNavLink
              to="/serve"
              onClick={() => handleMobileNavClick("/serve")}
            >
              事奉同工
            </MobileNavLink>
          </MobileNavItem>

          <MobileNavItem active={isActive("/contact")}>
            <MobileNavLink
              to="/contact"
              onClick={() => handleMobileNavClick("/contact")}
            >
              奉献
            </MobileNavLink>
          </MobileNavItem>

          <MobileNavItem active={location.pathname === "/login" && !isLoggedIn}>
            <MobileNavLink to="#" onClick={handleAuthClick}>
              {isLoggedIn ? "登出" : "登录"}
            </MobileNavLink>
          </MobileNavItem>
        </List>
      </Drawer>

      <LogoutConfirmDialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        onConfirm={handleConfirmLogout}
        username={useSelector((state) => state.auth.username)}
      />
    </>
  );
};

export default MobileNavbar;
